import React, { FC, ReactNode, useRef, useState } from 'react';
import DropdownList, {
  DropdownOption,
} from '@/src/components/clean/DropdownList/DropdownList';
import { useOnClickOutside } from '@/src/hooks/useOnClickOutside/useOnClickOutside';

import style from './dropdown.module.scss';
import KlicInput from '@/src/components/clean/Input/Input';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi';

type Props = {
  label: string;
  items: DropdownOption[];
  onClick: (value: string) => void;
  header?: ReactNode;
  footer?: ReactNode;
  value: string | string[];
  className?: string;
  error?: string;
  disabled?: boolean;
  name: string;
  id: string;
  isMultiselect?: boolean;
  showValue?: boolean;
  isDatepicker?: boolean;
  placeholder?: string;
  required?: boolean;
  infoText?: string;
};

const Dropdown: FC<Props> = ({
  label,
  items,
  onClick,
  header,
  footer,
  value,
  className,
  error,
  disabled,
  id,
  name,
  placeholder,
  isMultiselect = false,
  showValue = false,
  isDatepicker = false,
  required = false,
  infoText,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const ref = useRef<HTMLDivElement | null>(null);
  useOnClickOutside(ref as any, () => {
    setIsOpen(false);
  });

  return (
    <div ref={ref} className={`${style['dropdown']} ${className}`}>
      <KlicInput
        onClick={() => {
          if (disabled) return;
          setIsOpen(!isOpen);
        }}
        id={id}
        value={
          isMultiselect
            ? value
              ? (value as string[]).join(', ')
              : ''
            : showValue
            ? (value as string)
            : items.find((item) => item.value === value)?.label ?? ''
        }
        disabled={disabled}
        type={'text'}
        name={name}
        label={label}
        placeholder={placeholder}
        required={required}
        onChange={() => {}}
        error={error || ''}
        isDropdown={true}
        isDatepicker={isDatepicker}
        autocomplete="off"
        infoText={infoText}
      />
      {!disabled &&
        (!isOpen ? (
          <HiOutlineChevronDown
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (disabled) return;
              setIsOpen(!isOpen);
            }}
          />
        ) : (
          <HiOutlineChevronUp
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (disabled) return;
              setIsOpen(!isOpen);
            }}
          />
        ))}
      <DropdownList
        className={style['dropdown__list']}
        header={header}
        footer={footer}
        items={items}
        onClick={(value) => {
          onClick(value);
          if (!isMultiselect) setIsOpen(false);
        }}
        isMultiselect={isMultiselect}
        isOpen={isOpen}
        selectedItems={value as string[]}
        isCountry={showValue}
      />
    </div>
  );
};

export default Dropdown;
